export type CreatorFunction = () => any;

export class TypedModelCache<T> {
  readonly IS_BACKEND_ENV = globalThis.window === undefined;

  items: { [key: string]: T } = {};

  reset(): void {
    this.items = {};
  }

  putItem(key: string, value: T): void {
    // prevent caching for NestJS services, because it will persist,
    // i.e., future Antrag with same VP will get "fragen" from previous Antrag
    if (!this.IS_BACKEND_ENV) {
      this.items[key] = value;
    }
  }

  getItem(key: string): T {
    return this.items[key];
  }

  removeItem(key: string): void {
    delete this.items[key];
  }

  checkItem(key: string, creatorFunc: CreatorFunction): T {
    let result: T = this.getItem(key);
    if (result === undefined) {
      result = <T>creatorFunc();
      this.putItem(key, result);
    }
    return result;
  }
}
